import { render } from "./DetailsPage.vue?vue&type=template&id=121ce952&scoped=true"
import script from "./DetailsPage.vue?vue&type=script&lang=js"
export * from "./DetailsPage.vue?vue&type=script&lang=js"

import "./DetailsPage.vue?vue&type=style&index=0&id=121ce952&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121ce952"],['__file',"src/views/ServiceCenter/components/DetailsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "121ce952"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('121ce952', __exports__)) {
    api.reload('121ce952', __exports__)
  }
  
  module.hot.accept("./DetailsPage.vue?vue&type=template&id=121ce952&scoped=true", () => {
    api.rerender('121ce952', render)
  })

}


export default __exports__